import React, { useEffect, useContext } from 'react'
import { useLocation } from 'react-router-dom';
import Card from '../components/Card'
import Pagination from "../components/layout/Pagination";
import ProductContext from '../context/products/ProductContext'
import Spinner from '../components/layout/Spinner'

function SearchProducts() {
    const {
        totalPages,
        setTotalPages,
        handlePageChange,
        currentPage,
        setCurrentPage,
        fetchSearchedProducts,
        searchedProducts,
        setSearchedName,
        searchedName,
        loading
     } = useContext(ProductContext)

    const location = useLocation()


    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const sortBy = queryParams.get('sortBy') ?? '';
        const pageSize = queryParams.get('pageSize') ?? 8;
        const currentPage = queryParams.get('currentPage') ?? 1;
        const totalPages = queryParams.get('totalPages') ?? 0;
        const searchedName = queryParams.get('query') ?? '';
        setCurrentPage(currentPage)
        setTotalPages(totalPages)
        setSearchedName(searchedName)

        fetchSearchedProducts(searchedName, sortBy, pageSize, currentPage)
    }, [location.search]);

    if (loading) {
        return <Spinner />; // Прикажи некој индикатор додека не се наполни selectedOil
    }

    return (
        <div className='flex flex-col justify-start items-center'>
            <div>
                <h1 className='text-4xl font-bold mb-8 text-center'>Пребарување за '{searchedName}'</h1>
            </div>
            <div
                className={`grid gap-4 mt-[5%] text-xl ${searchedProducts.length === 1 ? 'grid-cols-1 justify-center' : searchedProducts.length === 2 ? 'grid-cols-2 justify-center' : 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'
                    }`}
            >
                {searchedProducts.length === 0 ? (
                    <p>Нема масло за прикажување според избраните критериуми.</p>
                ) : (
                    searchedProducts.map((product) => (
                        <Card key={product.id} item={product} className='mr-4 mb-4' />
                    ))
                )}
            </div>
            {searchedProducts.length > 0 && (
                <><div>Тековна страна: {currentPage}</div>
                    <Pagination
                        totalPages={totalPages}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                    /></>
            )}
        </div>
    )
}

export default SearchProducts
